import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  fetchArchitectureFailed,
  fetchArchitectureRequested,
  fetchArchitectureSucceeded,
  createArchitectureFailed,
  createArchitectureRequested,
  createArchitectureSucceeded,
  deleteArchitectureFailed,
  deleteArchitectureRequested,
  deleteArchitectureSucceeded,
} from '../../../actions';
import api from '../../../api';

// eslint-disable-next-line import/prefer-default-export
export function* fetchArchitectureRequest(factoryId) {
  yield put(fetchArchitectureRequested(factoryId));

  try {
    const { items } = yield call(request, api.getArchitectures, factoryId);

    const action = fetchArchitectureSucceeded(items);

    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchArchitectureFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* createArchitectureRequest(factoryId, localId, data) {
  yield put(
    createArchitectureRequested(localId, {
      ...data,
      factoryId,
    }),
  );

  try {
    const { item } = yield call(request, api.createArchitecture, factoryId, data, localId);

    const action = createArchitectureSucceeded(localId, item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createArchitectureFailed(localId, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteArchitectureRequest(id) {
  yield put(deleteArchitectureRequested(id));

  try {
    const { architecture } = yield call(request, api.deleteArchitecture, id);

    const action = deleteArchitectureSucceeded(architecture);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteArchitectureFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
